/* Céla — 1re photo de la galerie (thème v6)
   La galerie de la fiche commence toujours par la photo de la femme sur la taie
   (la même que sur l'accueil), puis montre les 3 photos de la couleur choisie.
   À l'arrivée sur la fiche (même avec ?variant=… depuis l'accueil) et à chaque
   changement de couleur, de format ou d'offre, la galerie s'affiche donc sur sa
   1re photo. Horizon remplace toute la galerie à chaque changement de variante :
   on vérifie pendant quelques instants qu'elle reste bien sur la 1re photo
   (sauf si la cliente fait défiler elle-même). */
(function () {
  'use strict';

  // La photo est-elle réellement affichée (au moins 60 % visible dans la zone) ?
  function isShown(scroller, slide) {
    var a = slide.getBoundingClientRect();
    var b = scroller.getBoundingClientRect();
    if (!a.width || !a.height) return true; // galerie masquée : rien à faire
    var w = Math.min(a.right, b.right) - Math.max(a.left, b.left);
    var h = Math.min(a.bottom, b.bottom) - Math.max(a.top, b.top);
    return w > 0 && h > 0 && (w * h) / (a.width * a.height) >= 0.6;
  }

  var job = 0;

  // Dès que la cliente fait défiler elle-même la galerie, on la laisse faire.
  function stopOnUserScroll(gallery) {
    if (!gallery || gallery.__celaWatch) return;
    gallery.__celaWatch = true;
    ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach(function (type) {
      gallery.addEventListener(
        type,
        function () {
          job++;
        },
        { passive: true }
      );
    });
  }

  function showFirst(scope) {
    var myJob = ++job;
    var tries = 0;

    (function attempt() {
      if (myJob !== job) return;
      tries++;

      var root = scope && scope.isConnected !== false ? scope : document;
      var gallery = root.querySelector('media-gallery') || document.querySelector('media-gallery');
      var slideshow = gallery && gallery.querySelector('slideshow-component');
      var scroller = slideshow && slideshow.querySelector('slideshow-slides');
      var first = gallery && gallery.querySelector('slideshow-slide');

      if (gallery && slideshow && scroller && first) {
        stopOnUserScroll(gallery);
        if (!isShown(scroller, first)) {
          try {
            slideshow.select(0, undefined, { animate: false });
          } catch (e) {
            try { scroller.scrollTo({ left: 0, top: 0, behavior: 'instant' }); } catch (e2) {}
          }
        }
      }

      if (tries < 15) setTimeout(attempt, 100);
    })();
  }

  document.addEventListener('variant:update', function (event) {
    var scope = event.target && event.target.closest ? event.target.closest('.shopify-section, dialog') : null;
    showFirst(scope || document);
  });

  function onLoad() {
    showFirst(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onLoad);
  else onLoad();
})();

/* Céla — photo du produit dans la fenêtre « Écrire un avis » (Judge.me)
   Judge.me garde en mémoire l'ancienne photo du produit pour cette fenêtre.
   On affiche à la place la photo principale actuelle de la fiche (balise og:image). */
(function () {
  'use strict';

  var type = document.querySelector('meta[property="og:type"]');
  var meta =
    document.querySelector('meta[property="og:image:secure_url"]') ||
    document.querySelector('meta[property="og:image"]');
  if (!type || type.getAttribute('content') !== 'product' || !meta) return;

  var src = meta.getAttribute('content') || '';
  if (!src) return;
  if (src.indexOf('//') === 0) src = 'https:' + src;
  src = src.replace(/^http:/, 'https:');

  var pending = false;

  function fix() {
    pending = false;
    var imgs = document.querySelectorAll('.jdgm-write-review-modal__product-image img');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].getAttribute('src') !== src) {
        imgs[i].removeAttribute('srcset');
        imgs[i].removeAttribute('data-src');
        imgs[i].setAttribute('src', src);
      }
    }
  }

  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    window.setTimeout(fix, 60);
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });

  fix();
})();
